import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

/** 行内加载圈 (继承文字颜色) */
export function Spinner({ className, label = "加载中" }: { className?: string; label?: string }) {
  return <Loader2 role="status" aria-label={label} className={cn("h-4 w-4 animate-spin", className)} />;
}
